var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnderlineArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    width: 32,
    height: 32,
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.21 37.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "underline_arrow_",
    "data-name": "underline (arrow)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.32,6.49h7.79v14.67c0,2.43,1.25,4.37,4.41,4.37s4.37-1.94,4.37-4.37V6.49h7.79v14.89c0,6.31-3.61,10.9-12.16,10.9s-12.2-4.6-12.2-10.87V6.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.71,37.51H6.29c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h26.43c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "8 0 0 0 0 8 8 0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderlineArrow);
export default __webpack_public_path__ + "static/media/UnderlineArrow.fa5821d2b228ce79f855b46651738eb6.svg";
export { ForwardRef as ReactComponent };